import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Sidebar from 'Views/Page/Content/Templates/WhatIfItemManagementCreationTemplate/Sidebar';
import MainContent from 'Views/Page/Content/Templates/WhatIfItemManagementCreationTemplate/MainContent';


const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    flex: 1,

  },
});

const WhatIfItemManagementCreationTemplate = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Sidebar />
      <MainContent />
    </Box>
  );
};

WhatIfItemManagementCreationTemplate.defaultProps = {
  className: '',
};

WhatIfItemManagementCreationTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhatIfItemManagementCreationTemplate);
